import { Component, Input, OnInit, Output } from '@angular/core';
import { NzImageService } from 'ng-zorro-antd/image';
import { BuyerProductManagementModel } from '../../buyer/models/buyer-products.model';
import { BuyerProductsService } from '../../buyer/services/buyer-product.service';

@Component({
	selector: 'app-image-with-loading',
	templateUrl: './image-with-loading.component.html',
	styleUrls: ['./image-with-loading.component.scss']
})
export class ImageWithLoadingComponent implements OnInit {


	@Input() height: number;
	@Input() width: number;
	@Input() image: any = null;
	@Input() productImages: any;
	@Input() isPreview: boolean = false;
	@Input() index: number;
	@Input() isProfile: boolean = false;

	isLoading: boolean;
	loader: string = "../../../../assets/loading.gif";
	isImage: boolean = false;

	constructor(
		private productService: BuyerProductsService<BuyerProductManagementModel>,
		private nzImageService: NzImageService,
	) { }

	ngOnInit(): void {
		if (this.productImages.length > this.index) {
			this.isLoading = true;
			this.productService.getResizeImage(this.productImages[this.index]['fileName'], this.width, this.height, this.isProfile).subscribe(
				(image) => {
					this.createImage(image);
				},
				(error) => {
					this.handleImageRetrievalError(error);
				}
			);
		} else {
			this.image = "../../../../assets/product_rocket.svg";
		}
	}

	createImage(image: Blob) {
		if (image && image.size > 0) {
			let reader = new FileReader();

			reader.addEventListener("load", () => {
				this.image = reader.result;
				this.isLoading = false;
			}, false);
			this.isImage = true;
			reader.readAsDataURL(image);
		} else {
			this.isLoading = false;
		}
	}

	preview(): void {
		if(this.productImages && this.isImage && this.isPreview){
			this.nzImageService.preview(this.productImages, { nzZoom: 1.5, nzRotate: 0 }).switchTo(this.index);
		}
	}

	handleImageRetrievalError(err: Error) {
		console.error(err);
		this.isLoading = false;
		// this.alertService.error("Problem retrieving profile photo.");
		this.image = "../../../../assets/errors-icon-18.jpg";
	}


}
